import {
    GET_AFE_FLEET_ITEM_CANCEL,
    GET_ASSET_FLEET_ITEM_CANCEL,
    GET_FLEET_ITEM_CANCEL, SET_ASSET_FLEET_ITEM_CANCEL, SET_FLEET_ITEM_CANCEL
} from "./FleetItemCancelType"

const getFleetItemCancel = (fleetItemId: any) => ({
    type: GET_FLEET_ITEM_CANCEL,
    fleetItemId
})

const setFleetItemCancel = (FleetItemCancel: any) => ({
    type: SET_FLEET_ITEM_CANCEL,
    FleetItemCancel: FleetItemCancel
})

const getAssetFleetItemCancel = (AssetfleetItemId: any) => ({
    type: GET_ASSET_FLEET_ITEM_CANCEL,
    AssetfleetItemId
})

const setAssetFleetItemCancel = (assetFleetItemCancel: any) => ({
    type: SET_ASSET_FLEET_ITEM_CANCEL,
    assetFleetItemCancel: assetFleetItemCancel
})

const getAfeFleetItemCancel = (afeFleetItemId: any) => ({
    type: GET_AFE_FLEET_ITEM_CANCEL,
    afeFleetItemId
})

export {
    getFleetItemCancel,
    setFleetItemCancel,
    getAssetFleetItemCancel,
    setAssetFleetItemCancel,
    getAfeFleetItemCancel
}